import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_END_POINTS } from "../ApiEndPoints";
import axios from "axios";

const initialState = {
  isLoading: false,
  full_name: null,
  email: null,
  password: null,
  user_id: null,
  isError: false,
  message: null,
  role: null,
  profilePic: "",
  token: null,
  isVerified: "",
  plans: [],
  planPaymentStatus: null, // New state for payment status
  paymentError: null, // New state for payment errors
  clientSecret: null, // New state for storing clientSecret from Stripe
};

export const loginAPI = createAsyncThunk(
  "loginAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_END_POINTS.login, credentials, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Something went wrong"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const signupAPI = createAsyncThunk(
  "signupAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_END_POINTS.signup, credentials, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const signupOTPVerify = createAsyncThunk(
  "signupOTPVerify",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_END_POINTS.signup, credentials, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const organizationListAPI = createAsyncThunk(
  "organizationListAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.organizationTypeList, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getPlansAPI = createAsyncThunk(
  "getPlansAPI",
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_END_POINTS.getPlans, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const createOrganizationAPI = createAsyncThunk(
  "createOrganizationAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.organizationSubmit,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const signupConfirmationCodeAPI = createAsyncThunk(
  "signupConfirmationCodeAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.signupConfirmation,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const resendOTPAPI = createAsyncThunk(
  "resendOTPAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_END_POINTS.resendOTP, credentials, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const emailForForgotPasswordAPI = createAsyncThunk(
  "emailForForgotPasswordAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.emailForgotPassword,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const resetPasswordAPI = createAsyncThunk(
  "resetPasswordAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.resetPassword,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const getLoginResponseAPI = createAsyncThunk(
  "getLoginResponseAPI",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.getLoginResponse,
        credentials,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Invalid credentials"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const requestActivationAPI = createAsyncThunk(
  "auth/requestActivation",
  async ({ email, argument }, { rejectWithValue }) => {
    try {
      const response = await axios.post(API_END_POINTS.requestActivation, {
        email,
        argument,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Request failed"
      );
    }
  }
);

// New async thunks for payment APIs
export const createPaymentIntentAPI = createAsyncThunk(
  "createPaymentIntentAPI",
  async ({ planId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.createPaymentIntent,
        { planId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Failed to create payment intent"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);

export const confirmPaymentIntentAPI = createAsyncThunk(
  "confirmPaymentIntentAPI",
  async ({ paymentIntentId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.confirmPaymentIntent,
        { paymentIntentId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        return rejectWithValue(
          error.response.data.message || "Failed to confirm payment"
        );
      } else {
        return rejectWithValue("Something went wrong!");
      }
    }
  }
);
// Google Login API
export const googleLoginAPI = createAsyncThunk(
  "auth/googleLoginAPI",
  async ({ token, userInfo }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.googleLogin,
        { userInfo }, // Request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Google login failed"
      );
    }
  }
);

// Facebook Login API
export const facebookLoginAPI = createAsyncThunk(
  "auth/facebookLoginAPI",
  async ({ token, userInfo }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_END_POINTS.facebookLogin,
        { userInfo }, // Request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Facebook login failed"
      );
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Existing cases for login, signup, etc.
    builder.addCase(loginAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loginAPI.fulfilled, (state, action) => {
      if (action.payload?.data?.user?.is_verified) {
        state.isLoading = false;
        state.isError = false;
        state.token = action.payload?.data?.token;
        state.email = action.payload?.data?.user?.email;
        state.full_name = action.payload?.data?.user?.full_name;
        state.user_id = action.payload?.data?.user?.id;
        state.profilePic = action.payload?.data?.user?.profile_picture;
        state.role = action.payload?.data?.user?.role?.name;
        state.password = action.payload?.data?.user?.password;
        state.isVerified = action.payload?.data?.user?.is_verified;
        state.message = action.payload.message;
        state.planPaymentStatus =
          action.payload.data?.UserProfile?.subscription_status;
        
        // Store token in localStorage for persistence
        if (action.payload?.data?.token) {
          localStorage.setItem('token', action.payload.data.token);
        }
      }
    });
    builder.addCase(loginAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(getLoginResponseAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getLoginResponseAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.email = action.payload?.data?.user?.email;
      state.full_name = action.payload?.data?.user?.full_name;
      state.user_id = action.payload?.data?.user?.id;
      state.profilePic = action.payload?.data?.user?.profile_picture;
      state.role = action.payload?.data?.user?.role?.name;
      state.password = action.payload?.data?.user?.password;
      state.message = action.payload.message;
    });
    builder.addCase(getLoginResponseAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(signupAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(signupAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.email = action.payload?.data?.user?.email;
      state.full_name = action.payload?.data?.user?.full_name;
      state.user_id = action.payload?.data?.user?.id;
      state.token = action.payload?.data?.token;
      state.message = action.payload.message;
    });
    builder.addCase(signupAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(signupOTPVerify.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(signupOTPVerify.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.token = action.payload?.data?.user?.token;
      state.email = action.payload?.data?.user?.email;
      state.full_name = action.payload?.data?.user?.full_name;
      state.password = action.payload.password;
      state.message = action.payload.message;
    });
    builder.addCase(signupOTPVerify.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(signupConfirmationCodeAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(signupConfirmationCodeAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.user_id = action.payload?.data?.user?.id;
      state.token = action.payload?.data?.token;
      state.email = action.payload?.data?.user?.email;
      state.role = action.payload?.data?.user?.role?.name;
      state.full_name = action.payload?.data?.user?.full_name;
      state.password = action.payload?.data?.user?.password;
      state.isVerified = action.payload?.data?.user?.is_verified;
      state.message = action.payload.message;
      
      // Store token in localStorage for persistence
      if (action.payload?.data?.token) {
        localStorage.setItem('token', action.payload.data.token);
      }
    });
    builder.addCase(signupConfirmationCodeAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(emailForForgotPasswordAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(emailForForgotPasswordAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.email = action.payload?.data?.email;
    });
    builder.addCase(emailForForgotPasswordAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    builder.addCase(requestActivationAPI.pending, (state) => {
      state.activationRequestStatus = "loading";
      state.activationRequestError = null;
    });
    builder.addCase(requestActivationAPI.fulfilled, (state) => {
      state.activationRequestStatus = "succeeded";
    });
    builder.addCase(requestActivationAPI.rejected, (state, action) => {
      state.activationRequestStatus = "failed";
      state.activationRequestError = action.payload;
    });

    builder.addCase(getPlansAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getPlansAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.plans = action.payload?.data || [];
      state.message = action.payload.message || "Plans fetched successfully";
    });
    builder.addCase(getPlansAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Failed to fetch plans";
    });

    // New cases for payment APIs
    builder.addCase(createPaymentIntentAPI.pending, (state) => {
      state.paymentStatus = "loading";
      state.paymentError = null;
    });
    builder.addCase(createPaymentIntentAPI.fulfilled, (state, action) => {
      state.paymentStatus = "succeeded";
      state.clientSecret = action.payload?.data?.clientSecret || null;
      state.message =
        action.payload.message || "Payment intent created successfully";
    });
    builder.addCase(createPaymentIntentAPI.rejected, (state, action) => {
      state.paymentStatus = "failed";
      state.paymentError = action.payload || "Failed to create payment intent";
    });

    builder.addCase(confirmPaymentIntentAPI.pending, (state) => {
      state.paymentStatus = "loading";
      state.paymentError = null;
    });
    builder.addCase(confirmPaymentIntentAPI.fulfilled, (state, action) => {
      state.paymentStatus = "succeeded";
      state.planPaymentStatus = "active"; // Update planPaymentStatus to active
      state.message =
        action.payload.message || "Payment confirmed successfully";
    });
    builder.addCase(confirmPaymentIntentAPI.rejected, (state, action) => {
      state.paymentStatus = "failed";
      state.paymentError = action.payload || "Failed to confirm payment";
    });
    // Existing cases for googleLoginAPI
    builder.addCase(googleLoginAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(googleLoginAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.user_id = action.payload?.data?.user?.id;
      state.token = action.payload?.data?.token;
      state.email = action.payload?.data?.user?.email;
      state.role = action.payload?.data?.role;
      state.full_name = action.payload?.data?.user?.full_name;
      state.password = action.payload?.data?.user?.password;
      state.isVerified = action.payload?.data?.user?.is_verified;
      state.message = action.payload.message;
      
      // Store token in localStorage for persistence
      if (action.payload?.data?.token) {
        localStorage.setItem('token', action.payload.data.token);
      }
    });
    builder.addCase(googleLoginAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });

    // New cases for facebookLoginAPI
    builder.addCase(facebookLoginAPI.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(facebookLoginAPI.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.user_id = action.payload?.data?.user?.id;
      state.token = action.payload?.data?.token;
      state.email = action.payload?.data?.user?.email;
      state.role = action.payload?.data?.role;
      state.full_name = action.payload?.data?.user?.full_name;
      state.password = action.payload?.data?.user?.password;
      state.isVerified = action.payload?.data?.user?.is_verified;
      state.message = action.payload.message;
      
      // Store token in localStorage for persistence
      if (action.payload?.data?.token) {
        localStorage.setItem('token', action.payload.data.token);
      }
    });
    builder.addCase(facebookLoginAPI.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.message = action.payload || "Something went wrong!";
    });
  },
});

export default authSlice.reducer;